import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const UploadList = Loadable(
  lazy(() => import("features/ReactUplody/UploadDemo"))
);

const routes = {
  path: "profilePhoto",
  children: [{ path: "", element: <UploadList /> }],
};

export default routes;
